import {Component, Input, OnInit} from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-friend-zone-tournaments',
  templateUrl: './friend-zone-tournaments.component.html',
  styleUrls: ['./friend-zone-tournaments.component.css']
})
export class FriendZoneTournamentsComponent implements OnInit {


  gameName = " ";

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
      this.getGameName(param['code']);
    });
  }

  changeRoute(param) {
    this.eventService.loadEventTournaments = true;
    if(param!= "") {
      this.eventService.getEventTournaments('friend-zone', 1, param).subscribe(res => {
        this.eventService.eventTournaments.next(res);
        this.eventService.loadEventTournaments = false;
      }, error => {
        this.eventService.eventTournaments.next({data: []});
        this.eventService.loadEventTournaments = false;
      })
    }else{
      this.eventService.loadEventTournaments = false;
    }
  }

  getGameName(param) {
    console.log(param);
    if (param == 'pubg')
      this.gameName = "pubg";
    else if (param == 'league-of-legends')
      this.gameName = "league-of-legends";
    else if (param == 'fortnite')
      this.gameName = "fortnite";
    else if (param == 'pubg-lite')
      this.gameName = "pubg-lite";
    else
      this.gameName = "rainbow-six-siege";

  }
}
